import { Component, EventEmitter, Input, Output } from '@angular/core';
import { buildButtonClasses } from '../button/button-classes.util';
import type { IconButtonDensity } from '../icons/action-icon';

@Component({
  selector: 'app-delete-icon-button',
  template: `
    <button
      type="button"
      [disabled]="disabled || loading"
      [attr.aria-label]="ariaLabel"
      [attr.title]="title || ariaLabel"
      [class]="buttonClasses"
      (click)="onClick.emit($event)"
    >
      <app-spinner *ngIf="loading" size="sm"></app-spinner>
      <app-action-icon
        *ngIf="!loading"
        name="delete"
        [density]="density"
        [class.text-red-600]="variant !== 'danger'"
        [class.dark:text-red-500]="variant !== 'danger'"
      ></app-action-icon>
    </button>
  `,
  styleUrls: ['../icons/icon-button.scss'],
  host: {
    class: 'tt-icon-btn-host',
    '[class.tt-icon-btn-host--toolbar]': 'density === "toolbar"',
    '[class.tt-icon-btn-host--row]': 'density === "row"',
  },
})
export class DeleteIconButtonComponent {
  /** `subtle` = toolbar chip (secondary surface, red icon); `danger` = solid error fill (e.g. photo overlays). */
  @Input() variant: 'subtle' | 'danger' = 'subtle';
  @Input() ariaLabel = 'Odstranit';
  @Input() title = '';
  @Input() disabled = false;
  @Input() loading = false;
  /** Empty follows context: 40px in the page header, 32px elsewhere. */
  @Input() density: IconButtonDensity = '';
  @Output() onClick = new EventEmitter<MouseEvent>();

  get buttonClasses(): string {
    return `${buildButtonClasses({
      variant: this.variant === 'danger' ? 'danger' : 'secondary',
      size: 'sm',
      iconOnly: true,
    })} shrink-0`;
  }
}
